import React from "react";
class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.visible = false;
    this.cachedMenu = undefined;
    this._isMounted = false;

    this.thisIsAMenuRef = React.createRef();
    this.pointerRef = React.createRef();

    this._removeMe = this._removeMe.bind(this);
    this._escapeKey = this._escapeKey.bind(this);
    this._menuClick = this._menuClick.bind(this);
  }

  componentDidMount() {
    this._removeMe();
    if (this.props.scrollElementId) {
      $("#" + this.props.scrollElementId).scroll(() => {
        this._removeMe();
      });
    }
    $(window).on("keyup", this._escapeKey);
    this._isMounted = true;
  }

  componentWillUnmount() {
    $(window).unbind("keyup", this._escapeKey);
    this._isMounted = false;
  }

  componentDidUpdate() {
    if (!this.state.width) {
      this.setState({
        width: $(".hidden-menu#" + this.props.menuId).outerWidth() + 1
      });
    }
    var menuData = Fraction.Helpers.getDataObject("_reserved.context-menu");
    if (
      this.state.width &&
      menuData.menuId === this.props.menuId &&
      !this.visible
    ) {
      this.visible = true;
      if (this._isMounted) {
        this.forceUpdate();
        $("#" + this.props.menuId)
          .hide()
          .fadeIn(100, () => {
            $(this).css("display", "");
            this.forceUpdate();
          });
      }
    } else if (menuData.menuId !== this.props.menuId) {
      this.visible = false;
    }

    var $pointer = $(this.pointerRef.current);
    if ($pointer.next().hasClass("menu-header")) {
      $pointer.addClass("pointer-header");
    }
  }

  _removeMe() {
    var menuData = Fraction.Helpers.getDataObject("_reserved.context-menu");
    if (menuData.menuId === this.props.menuId && this.visible) {
      if (menuData.closeCallback) {
        menuData.closeCallback();
      }

      $(menuData.refocusDOM).attr("aria-expanded", "false");
      $(menuData.refocusDOM)
        .css("outline", "none")
        .on("blur", function() {
          $(this)
            .off("blur")
            .css("outline", "");
        });
      $(menuData.refocusDOM).focus();

      menuData.menuId = undefined;
      if (menuData.calledContainer && menuData.calledContainer._isMounted) {
        menuData.calledContainer.forceUpdate();
      }
      menuData.position = undefined;
      for (var key in menuData) {
        if (menuData.hasOwnProperty(key)) {
          menuData[key] = undefined;
        }
      }
    }

    // Fix bug with mobile bookmark container
    Fraction.Helpers.runAfterRender(
      function() {
        if (this._isMounted) {
          this.forceUpdate();
        }
      }.bind(this)
    );
  }

  _escapeKey(e) {
    if (e.keyCode === 27) {
      this._removeMe();
    }
  }

  _menuClick(e) {
    e.stopPropagation();
  }

  render() {
    var menuData = Fraction.Helpers.getDataObject("_reserved.context-menu");
    var boxStyle, pointerStyle, menuSize, menu, i;
    let alignLeft = this.props.alignLeft;
    let alignRight = this.props.alignRight;
    if (menuData.menuId === this.props.menuId) {
      menu = { direction: this.props.direction || "up" };
      if (menuData.position) {
        menu.x = menuData.position.left;
        menu.y = menuData.position.top;
        alignLeft = menuData.alignLeft || this.props.alignLeft;
        alignRight = menuData.alignRight || this.props.alignRight;
      } else {
        menu.x = $(menuData.calledButtonDOM).offset().left;
        menu.y = $(menuData.calledButtonDOM).offset().top;
      }

      var calledHeight,
        calledWidth,
        containerHeight,
        containerWidth,
        containerTop,
        containerBottom,
        containerRight,
        containerLeft;
      if (menuData.calledButtonDOM) {
        calledHeight = $(menuData.calledButtonDOM).innerHeight();
        calledWidth = $(menuData.calledButtonDOM).innerWidth();
      } else if (menuData.boundingRect) {
        calledHeight = menuData.boundingRect.height;
        calledWidth = menuData.boundingRect.width;
        menu.x = menuData.boundingRect.left;
        menu.y = menuData.boundingRect.top;
      }
      var container = $(window);
      if (this.props.containerId) {
        container = $("#" + this.props.containerId);
      }
      containerHeight = container.height();
      containerWidth = container.width();
      containerTop = container.offset() ? container.offset().top : 0;
      containerLeft = container.offset() ? container.offset().left : 0;
      containerRight = containerLeft + containerWidth;
      containerBottom = containerTop + containerHeight;
      boxStyle = { top: menu.y, left: menu.x, width: "auto" }; // potentially need this.state.width
      pointerStyle = { top: menu.y, left: menu.x };
      menuSize = { width: 0, height: 0 };
      if (this.props.html) {
        // This is just going to be the elements from within (check their width)
        $.extend(true, boxStyle, {
          padding: "0",
          paddingTop: "0",
          paddingBottom: "0"
        });
      }
      pointerStyle = { top: menu.y, left: menu.x };

      if (
        this.lastWidth !== $("#" + this.props.menuId).outerWidth() ||
        this.lastHeight !== $("#" + this.props.menuId).outerHeight()
      ) {
        Fraction.Helpers.runAfterRender(
          function() {
            if (this._isMounted) {
              this.forceUpdate();
            }
          }.bind(this)
        );
      }
      this.lastWidth = $("#" + this.props.menuId).outerWidth();
      this.lastHeight = $("#" + this.props.menuId).outerHeight();

      var menuOuterWidth =
        this.props.expectedWidth || $("#" + this.props.menuId).outerWidth();
      var menuInnerHeight =
        this.props.expectedHeight || $("#" + this.props.menuId).innerHeight();

      // if the menu should be below, or
      // if the menu should be above, but the menu goes above the top of the page
      var leftover;
      if (
        menu.direction === "up" ||
        (menu.direction === "down" &&
          menu.y -
            calledHeight -
            menuInnerHeight -
            6 +
            (this.props.yOffset || 0) <
            containerTop)
      ) {
        menu.direction = "up";
        boxStyle.top = menu.y + calledHeight + 6 - (this.props.yOffset || 0);
        if (menu.x > containerWidth / 2 || this.props.forceLeft) {
          boxStyle.left = Math.max(
            containerLeft + 6,
            Math.min(
              containerRight - menuOuterWidth - 6,
              menu.x +
                calledWidth / 2 -
                menuOuterWidth +
                19 +
                (this.props.xOffset || 0)
            )
          );
          pointerStyle.right = 15;
          leftover = 0;
          pointerStyle.right = pointerStyle.right + leftover;
          delete pointerStyle.left;
        } else {
          boxStyle.left = Math.max(
            containerLeft + 6,
            Math.min(
              containerWidth - menuOuterWidth - 6,
              menu.x + calledWidth / 2 - 19 + (this.props.xOffset || 0)
            )
          );
          pointerStyle.left = 15;
          leftover = 0;
          pointerStyle.left = pointerStyle.left + leftover;
          delete pointerStyle.right;
        }
        delete pointerStyle.top;
      }

      if (menu.direction === "left") {
        boxStyle.top =
          menu.y - (menuInnerHeight + 14) / 2 - (this.props.yOffset || 0);
        boxStyle.left =
          menu.x + (menuOuterWidth + 28 + 6) - (this.props.xOffset || 0);
        pointerStyle.top =
          (menuInnerHeight + 14) / 2 + (this.props.yPointerOffset || 0);
        boxStyle.top = Math.max(boxStyle.top, 6);
        if (menu.y > containerHeight / 2 || this.props.forceTop) {
          pointerStyle.bottom = 15;
          delete pointerStyle.top;
        } else {
          delete pointerStyle.bottom;
          pointerStyle.top = 15;
        }
        delete pointerStyle.left;
      }

      if (menu.direction === "right") {
        boxStyle.top =
          menu.y - (menuInnerHeight + 14) / 2 - (this.props.yOffset || 0);
        boxStyle.left =
          menu.x - (menuOuterWidth + 28 - 6) - (this.props.xOffset || 0);
        pointerStyle.top =
          (menuInnerHeight + 14) / 2 + (this.props.yPointerOffset || 0);
        boxStyle.top = Math.max(boxStyle.top, 6);
        if (menu.y > containerHeight / 2 || this.props.forceTop) {
          pointerStyle.bottom = 15;
          delete pointerStyle.top;
        } else {
          delete pointerStyle.bottom;
          pointerStyle.top = 15;
        }
        delete pointerStyle.left;
      }

      // if the menu should be above, or
      // if the menu should be below, but the menu goes below the bottom of the page
      if (
        menu.direction === "down" ||
        (menu.direction === "up" &&
          menu.y + calledHeight + 6 - (this.props.yOffset || 0) >
            containerHeight - 6 - $("#" + this.props.menuId).outerHeight())
      ) {
        menu.direction = "down";

        // using Math.max() to make sure the menu doesn't go off the top of the page
        boxStyle.top = Math.max(
          menu.y - 0 - menuInnerHeight - 6 + (this.props.yOffset || 0),
          0
        );

        pointerStyle.left = (menuSize.width + 28) / 2;
        if (menu.x > containerWidth / 2 || this.props.forceLeft) {
          boxStyle.left = Math.max(
            containerLeft + 6,
            Math.min(
              containerWidth - $("#" + this.props.menuId).outerWidth() - 6,
              menu.x +
                calledWidth / 2 -
                $("#" + this.props.menuId).outerWidth() +
                19 +
                (this.props.xOffset || 0)
            )
          );
          pointerStyle.right = 15;
          delete pointerStyle.left;
        } else {
          boxStyle.left = Math.min(
            containerRight - menuOuterWidth - 6,
            Math.max(
              containerLeft + 6,
              menu.x + calledWidth / 2 - 19 + (this.props.xOffset || 0)
            )
          );
          delete pointerStyle.right;
          pointerStyle.left = 15;
        }
        delete pointerStyle.top;
      }
      if (alignLeft !== undefined) {
        leftover = boxStyle.left - alignLeft;
        boxStyle.left = alignLeft;
      }
      if (alignRight) {
        leftover = alignRight - (boxStyle.left + menuOuterWidth);
        boxStyle.left = alignRight - menuOuterWidth;
      }
    }

    if (this.props.customStyles) {
      $.extend(true, boxStyle, this.props.customStyles);
    }

    return (
      <span
        className={this.props.menuId === menuData.menuId ? "" : "hidden-menu"}
      >
        {!this.props.hideCover && (
          <div
            className={
              "context-menu-cover" +
              (this.props.menuId === menuData.menuId ? "" : " hidden-menu")
            }
            onClick={this._removeMe}
            onTouchStart={this._removeMe}
          />
        )}
        <div
          id={this.props.menuId}
          ref={this.thisIsAMenuRef}
          className={
            "context-menu " +
            (this.props.menuId === menuData.menuId ? "" : "hidden-menu")
          }
          style={boxStyle}
          onClick={this._menuClick}
        >
          <div
            ref={this.pointerRef}
            className={"pointer " + (menu ? menu.direction : "up")}
            style={this.props.pointerStyle || pointerStyle}
          />
          {this.props.children}
        </div>
      </span>
    );
  }
}

var MenuMixin = {
  // Set the menu
  _toggleMenu: function(e, args) {
    var menuId;
    if (args && args.menuId) {
      menuId = args.menuId;
    } else {
      menuId = $(e.currentTarget).data("menu-id");
      e.preventDefault();
      e.stopPropagation();
    }
    var menuData = Fraction.Helpers.getDataObject("_reserved.context-menu");
    //Added modal piece here for future menu dropdowns in modal windows
    if (menuData.menuId === menuId) {
      this._removeMenu(e, args);
    } else {
      this._showMenu(e, args);
    }
  },

  // Set the menu
  _showMenu: function(e, args, closeCallback) {
    this.menuVisible = false;
    var menuData = Fraction.Helpers.getDataObject("_reserved.context-menu");
    $(menuData.refocusDOM).attr("aria-expanded", "false");
    menuData.refocusDOM = "";
    this._removeMenu();

    this.stopMenuHide = true;
    setTimeout(() => {
      this.stopMenuHide = false;
    }, 250);

    this.menuVisible = true;
    menuData = Fraction.Helpers.getDataObject("_reserved.context-menu");

    menuData.calledContainer = this;
    if (args && args.menuId) {
      menuData.menuId = args.menuId;
      menuData.refocusDOM = $("#" + args.refocusDOMId);
      menuData.containerId = args.containerId;
      menuData.boundingRect = args.boundingRect;
      menuData.position = args.position;
      menuData.alignRight = args.alignRight;
      menuData.alignLeft = args.alignLeft;
      menuData.calledButtonDOM = e ? e.currentTarget : args.currentTarget;
      menuData.refocusDOM = e ? e.currentTarget : args.currentTarget;
    } else {
      menuData.menuId = $(e.currentTarget).data("menu-id");
      e.preventDefault();
      e.stopPropagation();
      if ($(e.currentTarget).data("target-dom-id")) {
        menuData.calledButtonDOM = $(
          "#" + $(e.currentTarget).data("target-dom-id")
        );
      } else {
        menuData.calledButtonDOM = e.currentTarget;
      }
      if ($(e.currentTarget).data("left") || $(e.currentTarget).data("top")) {
        menuData.position = {
          left: $(e.currentTarget).data("left"),
          top: $(e.currentTarget).data("top")
        };
      }
      menuData.refocusDOM = e.currentTarget;
    }
    if (args && args.closeCallback) {
      menuData.closeCallback = args.closeCallback;
    }

    if (this._isMounted) {
      this.forceUpdate();
    }

    $(e.currentTarget).attr("aria-expanded", "true");

    this.forceUpdate(function() {
      $("#" + menuData.menuId).focus();
    });
  },

  _removeMenu: function(menuId) {
    if (this.stopMenuHide) {
      return;
    }
    var menuData = Fraction.Helpers.getDataObject("_reserved.context-menu");
    if (menuId && typeof menuId === "string" && menuData.menuId !== menuId) {
      return;
    }
    if (
      this.menuVisible ||
      (menuData.calledContainer && menuData.calledContainer.menuVisible)
    ) {
      if (menuData.closeCallback) {
        menuData.closeCallback();
      }
    }

    $(menuData.refocusDOM).attr("aria-expanded", "false");
    $(menuData.refocusDOM).focus();

    var existed = this.menuVisible;
    this.menuVisible = false;
    menuData.menuId = undefined;
    if (menuData.calledContainer && menuData.calledContainer._isMounted) {
      menuData.calledContainer.forceUpdate();
    }
    menuData.position = undefined;
    for (var key in menuData) {
      if (menuData.hasOwnProperty(key)) {
        menuData[key] = undefined;
      }
    }

    return existed;
  },

  _redrawMenu: function() {
    var menuData = Fraction.Helpers.getDataObject("_reserved.context-menu");
    if (menuData.calledContainer && menuData.calledContainer._isMounted) {
      menuData.calledContainer.forceUpdate();
    }
  }
};

import Dispatcher from "../../dispatcher";

class TempMenu extends React.Component {
  constructor() {
    super();
    this.state = {
      open: false
    };
    this.close = this.close.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.open && this.state.open) {
      Dispatcher.bind(Dispatcher.CLOSE_MENU, this.close);
      Fraction.Reporter.gaEvent(this.props.openReport);
    } else if (prevState.open && !this.state.open) {
      Dispatcher.unbind(Dispatcher.CLOSE_MENU, this.close);
      Fraction.Reporter.gaEvent(this.props.closeReport);
    }
  }

  close() {
    this.setState({ open: false });
    Fraction.Reporter.gaEvent(this.props.closeReport);
  }

  onClick(e) {
    if (
      !this.state.open &&
      this.props.mobileModal &&
      Fraction.Helpers.isSmallScreen()
    ) {
      Fraction.Helpers.showModal(
        {
          closeCallback: this.close,
          ...this.props.mobileModal
        },
        this.button
      );
    } else {
      this._toggle();
    }
  }

  _toggle() {
    this.setState(
      prevState => {
        if (!prevState.open) {
          Dispatcher.emit(Dispatcher.CLOSE_MENU);
        }
        return { open: !prevState.open };
      },
      () => {
        this.button.focus();
      }
    );
  }

  _report(args) {
    if (args) {
      if (typeof args === "string") {
        Fraction.Reporter.gaEvent(args);
      } else {
        Fraction.Reporter.gaEvent(...args);
      }
    }
  }

  buttonRender() {
    const render = this.props.button.render;
    if (typeof render === "string") {
      return i18n.t(render);
    }
    return render;
  }

  render() {
    const {
      button: { render, ...buttonProps },
      close,
      offScreen,
      openReport,
      closeReport,
      mobileModal,
      pointer,
      ...props
    } = this.props;
    return (
      <div id="menu-container">
        <button
          {...buttonProps}
          ref={b => {
            this.button = b;
          }}
          onClick={this.onClick}
          aria-expanded={this.state.open}
        >
          {this.buttonRender()}
          {offScreen && <span className="offScreen">{i18n.t(offScreen)}</span>}
        </button>
        {this.state.open && (
          <div className="context-menu" {...props}>
            {this.props.children}
          </div>
        )}
        {this.state.open && (
          <div className="context-menu-cover" onClick={this.onClick} />
        )}
      </div>
    );
  }
}

TempMenu.defaultProps = {
  button: {}
};

export { Menu, MenuMixin, TempMenu };
